var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_123_7",
    "data-name": "Component 123 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10845",
    "data-name": "Rectangle 10845",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-horizontal",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M3,7H6.231",
    transform: "translate(0 0.231)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M3,17H9.462",
    transform: "translate(0 1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M18,17h3.231",
    transform: "translate(1.154 1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11302",
    "data-name": "Path 11302",
    d: "M15,7h6.462",
    transform: "translate(0.923 0.231)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11303",
    "data-name": "Path 11303",
    d: "M6,7.231a5.372,5.372,0,0,1,.164-1.9A2.154,2.154,0,0,1,7.33,4.164,5.372,5.372,0,0,1,9.231,4a5.372,5.372,0,0,1,1.9.164A2.154,2.154,0,0,1,12.3,5.33a5.373,5.373,0,0,1,.164,1.9,5.373,5.373,0,0,1-.164,1.9A2.154,2.154,0,0,1,11.132,10.3a5.372,5.372,0,0,1-1.9.164,5.372,5.372,0,0,1-1.9-.164A2.154,2.154,0,0,1,6.164,9.132,5.372,5.372,0,0,1,6,7.231Z",
    transform: "translate(0.231 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11304",
    "data-name": "Path 11304",
    d: "M12,17.231a5.373,5.373,0,0,1,.164-1.9,2.154,2.154,0,0,1,1.166-1.166,5.373,5.373,0,0,1,1.9-.164,5.373,5.373,0,0,1,1.9.164A2.154,2.154,0,0,1,18.3,15.33a5.373,5.373,0,0,1,.164,1.9,5.373,5.373,0,0,1-.164,1.9A2.154,2.154,0,0,1,17.132,20.3a5.373,5.373,0,0,1-1.9.164,5.373,5.373,0,0,1-1.9-.164,2.154,2.154,0,0,1-1.166-1.166A5.373,5.373,0,0,1,12,17.231Z",
    transform: "translate(0.693 0.769)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9bcdfd02bc487dc194634693e56be1b0.svg";
export { ForwardRef as ReactComponent };